import { useMutation } from 'glimmer-apollo'
import { parse } from 'graphql'

export function amendOrderFromParams(
  context: Object,
  variables: AmendOrderFromParamsInput
): Promise<AmendOrderFromParamsResponse | undefined | null> {
  return new Promise((resolve, reject) => {
    const amendOrderFromParamsMutation = useMutation<AmendOrderFromParamsResponse, { input: AmendOrderFromParamsInput }>(context, () => [
      mutation,
      {
        onError: (error) => {
          reject(new Error('Failed to amend order from params.', { cause: error }))
        },
        onComplete: (data: AmendOrderFromParamsResponse | undefined | null) => {
          resolve(data)
        }
      }
    ])

    amendOrderFromParamsMutation.mutate({
      input: variables
    })
  })
}

const mutation = parse(`
  mutation AmendOrderFromParams($input: AmendOrderFromParamsInput!) {
    amendOrderFromParams(input: $input) {
      ... on AmendOrderFromParamsSuccess {
        order {
          id
          balance {
            price {
              amount
              currency
              formatted
            }
            total {
              amount
              currency
              formatted
            }
          }
          currency
          customer {
            id
            name
            email
          }
          hasOpenDisputes
          sales {
            ... on Booking {
              id
              displayId
              startsAt
              endsAt
              timezone
              activitySnapshot {
                name
                description
              }
            }
          }
        }
      }
      ... on GenericError {
        message
      }
      ... on InvalidDataError {
        message
      }
      ... on NotFoundError {
        message
      }
    }
  }
`)
